import React from 'react';

interface Props {
  items: { title: string; text: string }[];
}

const FitWorkingWell: React.FC<Props> = ({ items }) => {
  if (items.length === 0) return null;
  return (
    <div className="fr-wins">
      {items.map((item, i) => (
        <div key={i} className="fr-win">
          <span className="fr-win__check" aria-hidden="true">✓</span>
          <span className="fr-win__text"><b>{item.title}</b>{item.text}</span>
        </div>
      ))}
    </div>
  );
};

export default FitWorkingWell;
